module.exports = __webpack_public_path__ + "img/fast-transactions4x.c8271e34.png";